<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { currencyUnitLabel } from "@/utils/currency";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      orderdetail: [],
      ismobile: false,
      orderinfo: [],
      activeapp: [],
      userinfo: [],
      ordersharingdata: [],
      loading: true,
      systemtype: 0,
      globalCurrey: "CNY",
      printer: "",
      ordererror: false,
    };
  },
  mounted() {
    this.title = this.$t("menuitems.devices.orderinfo");
    this.items = [
      {
        text: this.$t("menuitems.devices.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.devices.orders"),
        href: "/device/orders",
      },
      {
        text: this.$t("menuitems.devices.orderinfo"),
        active: true,
      },
    ];

    this.userinfo = JSON.parse(localStorage.getItem("user"));
    this.getorderinfo();
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    this.getsysteminfo();
  },
  methods: {
    getsysteminfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          var d = response.data.data;
          that.systemtype = parseInt(d.model);
          that.printer = d.printer;
          if (d.currey) {
            that.globalCurrey = d.currey;
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    currencyLabel(code) {
      return currencyUnitLabel(this, code || this.globalCurrey);
    },
    orderConsumer() {
      const detail = this.orderdetail || {};
      const name = detail.username != null ? String(detail.username).trim() : "";
      if (name && name !== "0") {
        return name;
      }
      const names = [];
      const rows = Array.isArray(this.orderinfo) ? this.orderinfo : [];
      rows.forEach((row) => {
        const user = row && row.user != null ? String(row.user).trim() : "";
        if (user && user !== "0" && names.indexOf(user) === -1) {
          names.push(user);
        }
      });
      return names.join("、");
    },
    lineUser(val) {
      const user = val && val.user != null ? String(val.user).trim() : "";
      if (user && user !== "0") {
        return user;
      }
      const detail = this.orderdetail || {};
      const name = detail.username != null ? String(detail.username).trim() : "";
      if (name && name !== "0") {
        return name;
      }
      return "";
    },
    getorderinfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "orderinfo",
            id: that.$route.query.id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.currey) {
            that.globalCurrey = response.data.currey;
          }
          if (response.data.status == 200) {
            that.orderdetail = response.data.data;
            that.orderinfo = response.data.infos;
          } else {
            that.ordererror = true;
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getseparateinfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getsharingdata",
            id: that.$route.query.id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status == 200) {
            that.ordersharingdata = response.data.data;
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    print_ticket: function () {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });
      that.$axios
        .post(
          that.apiuri,
          {
            action: "orderprint",
            id: that.$route.query.id,
            printer: that.printer,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
            that.getorderinfo();
          } else if ((response.data.status = 404)) {
            that.$message.error(that.$t("device.orders.info.noprint"));
          } else {
            that.$message.error(that.$t("global.failed"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
  },
  filters: {
    formatTimer: function (value) {
      value = value * 1000;
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" v-loading="loading" v-if="!ordererror">
          <!-- 订单基本信息卡片 -->
          <div class="card-header bg-primary text-white">
            <h5 class="card-title mb-0">
              <i class="ri-shopping-cart-line me-2"></i>
              {{ $t("device.orders.info.orderinfo") }}
            </h5>
          </div>
          
          <div class="card-body">
            <!-- 桌面端布局 -->
            <div class="d-none d-lg-block">
              <div class="row">
                <!-- 左侧订单信息 -->
                <div class="col-lg-6">
                  <div class="order-info-section">
                    <h6 class="section-title">
                      <i class="ri-file-text-line me-2"></i>
                      {{ $t("device.orders.info.basicinfo") }}
                    </h6>
                    <div class="info-grid">
                      <div class="info-item">
                        <span class="info-label">{{ $t("device.orders.info.sn") }}</span>
                        <span class="info-value">{{ orderdetail.sn }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">{{ $t("device.orders.info.id") }}</span>
                        <span class="info-value">{{ orderdetail.ED_id }}</span>
                      </div>
                      <div class="info-item" v-if="systemtype == 2">
                        <span class="info-label">{{ $t("device.orders.info.user") }}</span>
                        <span class="info-value">
                          <span v-if="orderConsumer()" class="badge badge-info">{{ orderConsumer() }}</span>
                          <span v-else class="text-muted">{{ $t("device.orders.nousername") }}</span>
                        </span>
                      </div>
                      <div class="info-item" v-if="systemtype == 0">
                        <span class="info-label">{{ $t("device.orders.info.goods") }}</span>
                        <span class="info-value">{{ orderdetail.gid }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">{{ $t("device.orders.info.price") }}</span>
                        <span class="info-value price-highlight">
                          {{ orderdetail.total }}-{{ orderdetail.refun_fee }} {{ currencyLabel() }}
                          <small class="text-muted">
                            ({{ orderdetail.goodstotal }}-{{ orderdetail.goodstotal * (orderdetail.refun_fee / orderdetail.total) }}
                            <span v-if="orderdetail.unity == 0">{{ $t("device.orders.info.ml") }}</span>
                            <span v-if="orderdetail.unity == 1">CC</span>
                            <span v-if="orderdetail.unity == 2">{{ $t("device.orders.info.ml") }}/{{ $t("device.orders.info.cup") }}</span>
                            <span v-if="orderdetail.unity == 3">{{ $t("device.orders.info.ml") }}/{{ $t("device.orders.info.bottle") }}</span>)
                          </small>
                        </span>
                      </div>
                      <div class="info-item" v-if="orderdetail.surpgoods > 0">
                        <span class="info-label">{{ $t("device.orders.info.baseinfo") }}</span>
                        <span class="info-value">
                          {{ $t("device.orders.info.value") }}: {{ orderdetail.goodstotal }}
                          {{ $t("device.orders.info.report") }}: {{ orderdetail.surpgoods }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 右侧状态信息 -->
                <div class="col-lg-6">
                  <div class="order-status-section">
                    <h6 class="section-title">
                      <i class="ri-time-line me-2"></i>
                      {{ $t("device.orders.info.statusinfo") }}
                    </h6>
                    <div class="info-grid">
                      <div class="info-item">
                        <span class="info-label">{{ $t("device.orders.info.creaet") }}</span>
                        <span class="info-value">{{ orderdetail.addtime | formatTimer }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">{{ $t("device.orders.info.pay") }}</span>
                        <span class="info-value">{{ orderdetail.paytime | formatTimer }}</span>
                      </div>
                      <div class="info-item" v-if="systemtype != 1">
                        <span class="info-label">{{ $t("device.orders.info.type") }}</span>
                        <span class="info-value payment-method">
                          <span v-if="orderdetail.payway == 0">
                            <i class="ri-wallet-line me-1"></i>{{ $t("device.orders.payment.cash") }}
                          </span>
                          <span v-if="orderdetail.payway == 1">
                            <i class="ri-wallet-line me-1"></i>{{ $t("device.orders.payment.wallet") }}
                          </span>
                          <span v-if="orderdetail.payway == 2">
                            <i class="fab fa-alipay me-1" style="color: #4dabf7"></i>{{ $t("device.orders.payment.alipay") }}
                          </span>
                          <span v-if="orderdetail.payway == 3">
                            <i class="fab fa-weixin me-1" style="color: #3cb034"></i>{{ $t("device.orders.payment.wxpay") }}
                          </span>
                          <span v-if="orderdetail.payway == 4">
                            <i class="fab fa-apple-pay me-1"></i>{{ $t("device.orders.payment.applepay") }}
                          </span>
                          <span v-if="orderdetail.payway == 5">
                            <i class="fab fa-google-wallet me-1"></i>{{ $t("device.orders.payment.googlewallet") }}
                          </span>
                          <span v-if="orderdetail.payway == 6">
                            <i class="fab fa-amazon-pay me-1"></i>{{ $t("device.orders.payment.amazonpay") }}
                          </span>
                          <span v-if="orderdetail.payway == 7">
                            <i class="fab fa-qq me-1"></i>{{ $t("device.orders.payment.qpay") }}
                          </span>
                          <span v-if="orderdetail.payway == 40">
                            <i class="fab fa-bestpay me-1"></i>{{ $t("device.orders.payment.bestpay") }}
                          </span>
                          <span v-if="orderdetail.payway == 41">
                            <i class="fab fa-sandpay me-1"></i>{{ $t("device.orders.payment.sandpay") }}
                          </span>
                          <span v-if="orderdetail.payway == 42">{{ $t("device.orders.payment.paymentasia") }}</span>
                          <span v-if="orderdetail.payway == 44">{{ $t("device.orders.payment.cmb") }}</span>
                          <span v-if="orderdetail.payway == 45">{{ $t("device.orders.payment.icbc") }}</span>
                          <span v-if="orderdetail.payway == 46">{{ $t("device.orders.payment.allinpay") }}</span>
                          <span v-if="orderdetail.payway == 55">{{ $t("device.orders.payment.keruyun") }}</span>
                          <span v-if="orderdetail.payway == 56">{{ $t("device.orders.payment.youhao") }}</span>
                          <span v-if="orderdetail.payway == 61">
                            <i class="fab fa-nyax me-1"></i>{{ $t("device.orders.payment.nayax") }}
                          </span>
                          <span v-if="orderdetail.payway == 77">{{ $t("device.orders.payment.coin") }}</span>
                          <span v-if="orderdetail.payway == 82">{{ $t("device.orders.payment.shouqianba") }}</span>
                        </span>
                      </div>
                      <div class="info-item" v-if="systemtype != 1">
                        <span class="info-label">{{ $t("device.orders.info.status") }}</span>
                        <span class="info-value">
                          <span class="badge badge-secondary" v-if="orderdetail.paytime > 0 && orderdetail.refun_fee == 0">
                            {{ $t("device.orders.status.orderpay") }}
                          </span>
                          <span class="badge badge-danger" v-if="orderdetail.paytime == 0">
                            {{ $t("device.orders.status.nopay") }}
                          </span>
                          <span class="badge badge-success" v-if="orderdetail.feedback == 1 && orderdetail.paytime > 0 && orderdetail.refun_fee == 0">
                            {{ $t("device.orders.status.pushdone") }}
                          </span>
                          <span class="badge badge-warning" v-if="orderdetail.refun_fee > 0 && orderdetail.paytime > 0">
                            {{ $t("device.orders.status.refund") }}
                          </span>
                          <span class="badge badge-success" v-if="orderdetail.feedback == 10 && orderdetail.paytime > 0 && orderdetail.refun_fee == 0">
                            {{ $t("device.orders.status.dropbag_error") }}
                          </span>
                          <span class="badge badge-success" v-if="orderdetail.feedback == 11 && orderdetail.paytime > 0 && orderdetail.refun_fee == 0">
                            {{ $t("device.orders.status.getcup_error") }}
                          </span>
                          <span class="badge badge-success" v-if="orderdetail.feedback == 12 && orderdetail.paytime > 0 && orderdetail.refun_fee == 0">
                            {{ $t("device.orders.status.flow_error") }}
                          </span>
                        </span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">{{ $t("device.orders.info.ticket") }}</span>
                        <span class="info-value">
                          <el-tag type="danger" v-if="orderdetail.ticket == 0" @click="print_ticket" style="cursor: pointer;">
                            {{ $t("device.orders.info.noprintticket") }}
                          </el-tag>
                          <el-tag type="success" v-else @click="print_ticket" style="cursor: pointer;">
                            {{ $t("device.orders.info.printticket", { pice: orderdetail.ticket }) }}
                          </el-tag>
                        </span>
                      </div>
                      <div class="info-item" v-if="orderdetail.mark">
                        <span class="info-label">{{ $t("device.orders.info.mark") }}</span>
                        <span class="info-value">
                          <el-tag type="danger">{{ orderdetail.mark }}</el-tag>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 移动端布局 -->
            <div class="d-lg-none">
              <div class="mobile-order-info">
                <div class="info-card mb-3">
                  <h6 class="card-title">
                    <i class="ri-file-text-line me-2"></i>
                    {{ $t("device.orders.info.basicinfo") }}
                  </h6>
                  <div class="info-list">
                    <div class="info-row">
                      <span class="label">{{ $t("device.orders.info.sn") }}</span>
                      <span class="value">{{ orderdetail.sn }}</span>
                    </div>
                    <div class="info-row">
                      <span class="label">{{ $t("device.orders.info.id") }}</span>
                      <span class="value">{{ orderdetail.ED_id }}</span>
                    </div>
                    <div class="info-row" v-if="systemtype == 2">
                      <span class="label">{{ $t("device.orders.info.user") }}</span>
                      <span class="value">
                        <span v-if="orderConsumer()" class="badge badge-info">{{ orderConsumer() }}</span>
                        <span v-else>{{ $t("device.orders.nousername") }}</span>
                      </span>
                    </div>
                    <div class="info-row" v-if="systemtype == 0">
                      <span class="label">{{ $t("device.orders.info.goods") }}</span>
                      <span class="value">{{ orderdetail.gid }}</span>
                    </div>
                    <div class="info-row">
                      <span class="label">{{ $t("device.orders.info.price") }}</span>
                      <span class="value">{{ orderdetail.total }}-{{ orderdetail.refun_fee }} {{ currencyLabel() }}</span>
                    </div>
                  </div>
                </div>

                <div class="info-card mb-3">
                  <h6 class="card-title">
                    <i class="ri-time-line me-2"></i>
                    {{ $t("device.orders.info.statusinfo") }}
                  </h6>
                  <div class="info-list">
                    <div class="info-row">
                      <span class="label">{{ $t("device.orders.info.creaet") }}</span>
                      <span class="value">{{ orderdetail.addtime | formatTimer }}</span>
                    </div>
                    <div class="info-row">
                      <span class="label">{{ $t("device.orders.info.pay") }}</span>
                      <span class="value">{{ orderdetail.paytime | formatTimer }}</span>
                    </div>
                    <div class="info-row" v-if="systemtype != 1">
                      <span class="label">{{ $t("device.orders.info.type") }}</span>
                      <span class="value">
                        <span v-if="orderdetail.payway == 0">{{ $t("device.orders.payment.cash") }}</span>
                        <span v-if="orderdetail.payway == 1">{{ $t("device.orders.payment.wallet") }}</span>
                        <span v-if="orderdetail.payway == 2">{{ $t("device.orders.payment.alipay") }}</span>
                        <span v-if="orderdetail.payway == 3">{{ $t("device.orders.payment.wxpay") }}</span>
                        <span v-if="orderdetail.payway == 4">{{ $t("device.orders.payment.applepay") }}</span>
                        <span v-if="orderdetail.payway == 5">{{ $t("device.orders.payment.googlewallet") }}</span>
                        <span v-if="orderdetail.payway == 6">{{ $t("device.orders.payment.amazonpay") }}</span>
                        <span v-if="orderdetail.payway == 7">{{ $t("device.orders.payment.qpay") }}</span>
                        <span v-if="orderdetail.payway == 40">{{ $t("device.orders.payment.bestpay") }}</span>
                        <span v-if="orderdetail.payway == 41">{{ $t("device.orders.payment.sandpay") }}</span>
                        <span v-if="orderdetail.payway == 42">{{ $t("device.orders.payment.paymentasia") }}</span>
                        <span v-if="orderdetail.payway == 44">{{ $t("device.orders.payment.cmb") }}</span>
                        <span v-if="orderdetail.payway == 45">{{ $t("device.orders.payment.icbc") }}</span>
                        <span v-if="orderdetail.payway == 46">{{ $t("device.orders.payment.allinpay") }}</span>
                        <span v-if="orderdetail.payway == 55">{{ $t("device.orders.payment.keruyun") }}</span>
                        <span v-if="orderdetail.payway == 56">{{ $t("device.orders.payment.youhao") }}</span>
                        <span v-if="orderdetail.payway == 61">{{ $t("device.orders.payment.nayax") }}</span>
                        <span v-if="orderdetail.payway == 77">{{ $t("device.orders.payment.coin") }}</span>
                        <span v-if="orderdetail.payway == 82">{{ $t("device.orders.payment.shouqianba") }}</span>
                      </span>
                    </div>
                    <div class="info-row" v-if="systemtype != 1">
                      <span class="label">{{ $t("device.orders.info.status") }}</span>
                      <span class="value">
                        <span class="badge badge-secondary" v-if="orderdetail.paytime > 0 && orderdetail.refun_fee == 0">
                          {{ $t("device.orders.status.orderpay") }}
                        </span>
                        <span class="badge badge-danger" v-if="orderdetail.paytime == 0">
                          {{ $t("device.orders.status.nopay") }}
                        </span>
                        <span class="badge badge-success" v-if="orderdetail.feedback == 1 && orderdetail.paytime > 0 && orderdetail.refun_fee == 0">
                          {{ $t("device.orders.status.pushdone") }}
                        </span>
                        <span class="badge badge-warning" v-if="orderdetail.refun_fee > 0 && orderdetail.paytime > 0">
                          {{ $t("device.orders.status.refund") }}
                        </span>
                      </span>
                    </div>
                    <div class="info-row">
                      <span class="label">{{ $t("device.orders.info.ticket") }}</span>
                      <span class="value">
                        <el-tag type="danger" v-if="orderdetail.ticket == 0" @click="print_ticket" style="cursor: pointer;">
                          {{ $t("device.orders.info.noprintticket") }}
                        </el-tag>
                        <el-tag type="success" v-else @click="print_ticket" style="cursor: pointer;">
                          {{ $t("device.orders.info.printticket", { pice: orderdetail.ticket }) }}
                        </el-tag>
                      </span>
                    </div>
                    <div class="info-row" v-if="orderdetail.mark">
                      <span class="label">{{ $t("device.orders.info.mark") }}</span>
                      <span class="value">
                        <el-tag type="danger">{{ orderdetail.mark }}</el-tag>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 订单商品详情卡片 -->
        <div class="card mt-4" v-if="!ordererror">
          <div class="card-header bg-info text-white">
            <h5 class="card-title mb-0">
              <i class="ri-list-check me-2"></i>
              {{ $t("device.orders.info.goodslist") }}
            </h5>
          </div>
          <div class="card-body">

            <!-- 桌面端商品列表 -->
            <div class="d-none d-lg-block">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("device.orders.info.listno") }}</th>
                      <th>{{ $t("device.hd.no") }}</th>
                      <th>{{ $t("device.orders.info.goods") }}</th>
                      <th v-if="systemtype == 2">{{ $t("device.orders.info.user") }}</th>
                      <th>{{ $t("device.orders.orderprice") }}</th>
                      <th>{{ $t("device.orders.salsevalues") }}</th>
                      <th>{{ $t("device.orders.dissipate") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(val, idx) in orderinfo" :key="idx">
                      <td>
                        <span class="badge badge-primary">{{ idx + 1 }}</span>
                      </td>
                      <td>
                        <code>
                          <span v-if="!val.edid">{{ orderdetail.ED_id }}</span>
                          <span v-else>{{ val.edid }}</span>
                          #{{ val.hd_no }}
                        </code>
                      </td>
                      <td>
                        <span v-if="val.title" class="fw-bold">{{ val.title }}</span>
                        <span v-else class="text-muted">{{ $t("device.orders.nogoodsname") }}</span>
                      </td>
                      <td v-if="systemtype == 2">
                        <span v-if="lineUser(val)" class="badge badge-info">{{ lineUser(val) }}</span>
                        <span v-else class="text-muted">{{ $t("device.orders.nousername") }}</span>
                      </td>
                      <td>
                        <span class="fw-bold text-success">{{ val.price }} {{ currencyLabel() }}</span>
                      </td>
                      <td>
                        <span class="fw-bold">{{ val.value }}</span>
                        <small class="text-muted">
                          <span v-if="orderdetail.ED_id.substring(0, 4) == 7710">{{ $t("device.orders.pack") }}</span>
                          <span v-else>ML</span>
                        </small>
                      </td>
                      <td>
                        <small class="text-muted">{{ val.paytime | formatTimer }}</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- 移动端商品列表 -->
            <div class="d-lg-none">
              <div class="goods-list-mobile">
                <div v-for="(val, idx) in orderinfo" :key="idx" class="goods-item mb-3">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <h6 class="card-title mb-1">
                            <span class="badge badge-primary me-2">{{ idx + 1 }}</span>
                            <span v-if="val.title">{{ val.title }}</span>
                            <span v-else class="text-muted">{{ $t("device.orders.nogoodsname") }}</span>
                          </h6>
                          <p class="card-text mb-1">
                            <small class="text-muted">
                              <code>
                                <span v-if="!val.edid">{{ orderdetail.ED_id }}</span>
                                <span v-else>{{ val.edid }}</span>
                                #{{ val.hd_no }}
                              </code>
                            </small>
                          </p>
                        </div>
                        <div class="col-6 text-end">
                          <div class="price-info">
                            <div class="fw-bold text-success">{{ val.price }} {{ currencyLabel() }}</div>
                            <div class="text-muted">
                              {{ val.value }}
                              <span v-if="orderdetail.ED_id.substring(0, 4) == 7710">{{ $t("device.orders.pack") }}</span>
                              <span v-else>ML</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2" v-if="systemtype == 2">
                        <div class="col-12">
                          <small class="text-muted">
                            {{ $t("device.orders.info.user") }}: 
                            <span v-if="lineUser(val)" class="badge badge-info">{{ lineUser(val) }}</span>
                            <span v-else>{{ $t("device.orders.nousername") }}</span>
                          </small>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-12">
                          <small class="text-muted">
                            {{ $t("device.orders.dissipate") }}: {{ val.paytime | formatTimer }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 错误状态显示 -->
        <div v-else class="card">
          <div class="card-body text-center">
            <el-empty :description="$t('device.order.ordererror')"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* 订单详情页面样式优化 */
.card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.section-title {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}

.info-grid {
  display: grid;
  gap: 0.75rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f8f9fa;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 500;
  color: #6c757d;
  min-width: 120px;
}

.info-value {
  color: #212529;
  text-align: right;
  flex: 1;
}

.price-highlight {
  color: #28a745;
  font-weight: 600;
}

.payment-method {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

/* 移动端样式 */
.mobile-order-info {
  padding: 0;
}

.info-card {
  background: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1rem;
  border: 1px solid #e9ecef;
}

.info-card .card-title {
  color: #495057;
  font-weight: 600;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0;
}

.info-row .label {
  font-weight: 500;
  color: #6c757d;
  font-size: 0.85rem;
}

.info-row .value {
  color: #212529;
  font-size: 0.85rem;
  text-align: right;
}

/* 商品列表样式 */
.table-responsive {
  border-radius: 0.5rem;
  overflow: hidden;
}

.table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

.goods-list-mobile .goods-item {
  border-radius: 0.5rem;
}

.goods-item .card {
  border: 1px solid #e9ecef;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.goods-item .card-body {
  padding: 0.75rem;
}

.price-info {
  text-align: right;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .info-value {
    text-align: left;
  }
  
  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .info-row .value {
    text-align: left;
  }
}

/* 徽章样式优化 */
.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.badge-primary {
  background-color: #007bff;
}

.badge-info {
  background-color: #17a2b8;
}

.badge-success {
  background-color: #28a745;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-danger {
  background-color: #dc3545;
}

.badge-secondary {
  background-color: #6c757d;
}

/* 代码样式 */
code {
  background-color: #f8f9fa;
  color: #e83e8c;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
}
</style>